import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Globals } from 'projects/shared/models/Globals';

@Component({
  selector: 'app-coloring-game-dialog',
  templateUrl: './coloring-game-dialog.component.html',
  styleUrls: []
})
export class ColoringGameDialogComponent implements OnInit {
  saveFn: () => void;
  clearFn: () => void;
  globals=Globals;
  constructor(
    public dialogRef: MatDialogRef<ColoringGameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      information : string,
      saveFn : () => void,
      clearFn : () => void
    }
  ) {
    this.saveFn = data.saveFn;
    this.clearFn = data.clearFn;
  }

  ngOnInit() {
  }
  saveImage() {
    this.saveFn && this.saveFn();
  }

  clear() {
    this.clearFn && this.clearFn();
    this.dialogRef.close(false);
  }

}
